<script>
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Router from '../../States/Router';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';

	export let index = 0;

	let properties = {};
	let book = {};
	let intros = {};
	let active = true;

	async function updateSlider(slides) {
		active = Slider.check(index, 'chapters', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
			if (active && properties.book) {
				book = await Data.relative(`books/${properties.book}`);
				intros = await Data.relative('intro/index');
				title();
				canonical();
			}
		}
	}

	function title() {
		if (active)
			Helper.title(book.name);
	}

	function canonical() {
		if (active)
			Helper.canonical(book.uri);
	}

	function previous() {
		Slider.route('previous', 'next');
	}

	function toPericope(event, book, chapter, pericope) {
		Helper.prevent(event);
		Router.push(`/${book.uri}/${chapter.number}`);
		const location = `${properties.book}_${chapter.number}`;
		Slider.route(['chapter', [location, {pericope: pericope.code}]]);
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	h1 {
		margin-top: 1.5em !important;
	}

	div.testament {
		margin-bottom: 3em;
	}

	div.testament .button {
		text-align: left;
	}

	div.intro {
		font-family: Bitter, serif;
		font-weight: 300;
		font-size: 1.5em;
		font-style: italic;
		color: var(--tertiary-color);
		margin-bottom: 4rem;
		line-height: 1.3em;
	}

	h3.quick {
		font-weight: 400;
		color: var(--secondary-color);
		margin-top: 0 !important;
		margin-bottom: .5em;
		margin-left: .4em;
	}

	div.quick {
		margin-bottom: 4rem;
	}

	div.quick a {
		display: inline-block;
		font-family: Bitter, serif;
		font-size: .8em;
		font-weight: 600;
		color: var(--primary-color);
		width: 2.3em;
		background: var(--secondary-background-light);
		text-align: center;
		border-radius: .3em;
		padding: .1em 0;
		margin: 0 .75em .75em 0;
	}

	div.quick a.active {
		color: var(--background);
		background: var(--primary-color);
	}

	div.chapters div.list {
		margin-bottom: 1.5em;
	}

	div.chapters h3 {
		font-size: 1.25em;
		margin: 0;
	}

	div.list div.name i {
		margin-right: .5em;
		opacity: .5;
	}

	@media (max-device-width: 768px) {
		h1 {
			margin-top: 0 !important;
		}

		div.intro,
		div.quick {
			margin-bottom: 2rem;
		}
	}
</style>

<div class="box feature" class:active>
	{#if Helper.is(book, intros)}
		<div class="menu">
			<div class="begin">
				<a class="item" href="/nieuwe-testament">
					<i class="fas fa-chevron-left"></i>
				</a>
				<div class="title">{book.name}</div>
			</div>
			<div class="end">
				<div class="item" on:click="{event => Slider.close()}">
					<i class="fas fa-times"></i>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="testament">
				<a class="button attention" href="/oude-testament">
					<i class="fad fa-chevron-left"></i>
					Oude Testament
				</a>
				<a class="button attention" href="/nieuwe-testament">
					<i class="fad fa-chevron-left"></i>
					Nieuwe Testament
				</a>
			</div>
			<h1>{book.name}</h1>
			{#if !Helper.undefined(intros[`${book.code}_1`])}
				<div class="intro">{intros[`${book.code}_1`]}</div>
			{/if}
			<h3 class="solid quick">Hoofdstukken</h3>
			<div class="quick">
				{#each book.chapters as chapter}
					<a href="/{book.uri}/{chapter.number}" class:active="{properties.chapter == chapter.number}">{chapter.number}</a>
				{/each}
			</div>
			<div class="chapters">
				{#each book.chapters as chapter}
					<h3 class="solid list">
						<a href="/{book.uri}/{chapter.number}">
							{book.name} <span>{chapter.number}</span>
						</a>
					</h3>
					<div class="solid list">
						{#each chapter.pericopes as pericope}
							<div class="item" href="/{book.uri}/{chapter.number}" on:click="{event => toPericope(event, book, chapter, pericope)}">
								<i class="fad fa-chevron-right"></i>
								<div class="name">
									<i class="fad fa-bookmark"></i>
									{pericope.title}
								</div>
							</div>
						{/each}
					</div>
				{/each}
			</div>
		</div>
	{/if}
</div>